import { useEffect, useRef } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { guildsAtom, selGuildAtom, latencyAtom } from '../atoms/guild';
import { post } from '../lib/api';

interface RawGuild { id: string; name: string; icon?: string | null; }
interface StatsResp { guilds?: RawGuild[]; latency?: number; }

/** Mount once in App — loads guild list into global atom and polls. */
export function useGuildData(enabled = true) {
  const setGuilds  = useSetAtom(guildsAtom);
  const [selId, setSelId] = useAtom(selGuildAtom);
  const setLatency = useSetAtom(latencyAtom);
  const selRef     = useRef(selId);
  selRef.current   = selId;

  useEffect(() => {
    if (!enabled) return;

    let timer: ReturnType<typeof setInterval>;

    const load = async () => {
      try {
        const data = await post<StatsResp>('/panel/stats');
        if (data.guilds?.length) {
          setGuilds(data.guilds.map(g => ({ id: g.id, name: g.name, icon: g.icon ?? null })));
          if (!selRef.current) setSelId(data.guilds[0].id);
        }
        if (data.latency != null) setLatency(data.latency);
      } catch { /* silent */ }
    };

    load();
    timer = setInterval(load, 15_000);
    return () => clearInterval(timer);
  }, [enabled]); // eslint-disable-line react-hooks/exhaustive-deps
}
